import React, { useMemo } from 'react';
import navCss from './navbar.module.scss';
import { useDispatch, useSelector } from "react-redux";
import { sortNoIdComponents } from '../helpers/sort-components';
import RenderedComponent from './RenderedComponent';
/**
 * Responsible for the logic of the navigation bar
 * 
 */
function Navbar() {

  const nav = useSelector(state => state.datareducer.navBar);

  const sortedComponents = useMemo(() => sortNoIdComponents(nav), [nav]);
  const components = sortedComponents.map(orderedComponent => (
    <RenderedComponent key={orderedComponent.id} value={orderedComponent} />
  ));


  return (
    <>
      <div className={navCss.mobile_bar}>
        <div className={navCss.mobile_bar_menu}>{components}</div>
      </div>
    </>
  );
}
export default Navbar;